import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { RpaConnectedNodes } from 'src/app/_models/reactive-power-analysis';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReactivePowerAnalysisService {

  setReactivePowerAnalysisRunning(isRunning: boolean) {
    localStorage.setItem("isReactivePowerAnalysisRunning", "" + isRunning);
  }

  setRPADataAvailable(areRPADataAvailable: boolean) {
    localStorage.setItem("areRPADataAvailable", "" + areRPADataAvailable);
  }

  isReactivePowerAnalysisRunning(): boolean {
    let isReactivePowerAnalysisRunning: boolean = false;

    const isReactivePowerAnalysisRunningStr: string = localStorage.getItem("isReactivePowerAnalysisRunning");
    if (isNotNullOrUndefined(isReactivePowerAnalysisRunningStr)) {
      if (isReactivePowerAnalysisRunningStr === "true") {
        isReactivePowerAnalysisRunning = true;
      }
    }

    return isReactivePowerAnalysisRunning;
  }

  areRPADataAvailable() {
    let areRPADataAvailable: boolean = false;

    const areRPADataAvailableStr: string = localStorage.getItem("areRPADataAvailable");
    if (isNotNullOrUndefined(areRPADataAvailableStr)) {
      if (areRPADataAvailableStr === "true") {
        areRPADataAvailable = true;
      }
    }
    return areRPADataAvailable;
  }

  constructor(
    private httpClient: HttpClient
  ) { }

  getConnectedNodesActiveAndReactivePower(topologyId: string, startTime: string, endTime: string){
    return this.httpClient.get<Array<RpaConnectedNodes>>(environment.API_BASE_URL + "chMeasurement/getConnectedNodesActiveAndReactivePower/" + topologyId + "/" + startTime + "/" + endTime);
  }
}

